module.exports = __webpack_public_path__ + "static/media/object360-product.028f5dd9.jpg";